import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Wrapper } from './components/Wrapper';

export const ResendVerificationSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('', { keyPrefix: 'emailVerification' });
  return (
    <Wrapper>
      <Stack gap={2}>
        <Typography variant="h2">{t('resendVerificationSuccess.title')}</Typography>
        <Typography>{t('resendVerificationSuccess.body')}</Typography>
      </Stack>
      <Button onClick={() => navigate('/')} sx={{ fontSize: '0.875rem', mt: 3 }}>
        {t('resendVerificationSuccess.continueToShippo')}
      </Button>
    </Wrapper>
  );
};
